import type BaseModel from "../models/BaseModel";
import GroupAddress from "../models/GroupAdress";
import type BaseModelMap from "../models/BaseModelMap";
import TreeViewModel from "../models/TreeviewModel";
import TreeMenuIcon from "../components/NavigationTree2/TreeMenuIcon";
import { askForGroupAddressUpdate } from "../addressGeneration/addressGenerator";
import { itx } from "../translationItx/itx";
import ConfirmDialog from "../modelDialogs/ConfirmDialog";
import { later } from "../models/utils";
import { isDevelopmentEnvironment } from "../estada-config";
import ExportGroupAdressesDialog from "../modelDialogs/ExportGroupAdressesDialog";
import { ProjectLicenseType } from "../models/ProjectLicense";
import { title } from "process";
import { ApplicationMode } from "../models/SettingsEnums";

export default class GroupAddressesTreeViewModel extends TreeViewModel {
  constructor(obj: BaseModel) {
    super(obj);
  }
  get typedObj(): BaseModelMap<GroupAddress> {
    return this.obj as BaseModelMap<GroupAddress>;
  }

  get isSelectable(): boolean {
    return false;
  }

  get isFolder(): boolean {
    return true;
  }

  getTagNeeded(): boolean {
    return false;
  }
  getDisableEdit(): boolean {
    return true;
  }

  get childCollection(): Array<BaseModel> | undefined {
    const res = this.typedObj.sortIntBy("address");
    return res;
  }

  // get iconUrl(): string | undefined {
  //   if (this.typedObj) {
  //     return "las la-grip-vertical";
  //   }

  //   return undefined;
  // }

  getTitlePostfix(): string | JSX.Element {
    if (state.settings.applicationMode === ApplicationMode.ConceptOne) return "";
    let max = 32;
    if (this.typedObj.size > max) {
      const imgSrcWarning = "/images/alert.png"; // no itx

      return (
        <div style={{ display: "flex", flexDirection: "row" }}>
          <img
            src={imgSrcWarning}
            data-tooltip-id="tv-tooltip"
            data-tooltip-html={itx(
              ".addressgroupWithToMutchElements",
              "Diese Addressgruppe enthält zuviele Elemente<br>Wähle ein anderes Adressschema",
            )}
            data-tooltip-place="right"
            data-tooltip-variant="error"
            style={{
              width: "25px",
              height: "25px",
              marginLeft: "10px",
              position: "relative",
            }}
          />
        </div>
      );
    } else {
      if (isDevelopmentEnvironment()) {
        let count = 0;
        if (this.childCollection) {
          for (const a1 of this.typedObj.asArray()) {
            for (const a2 of a1.children.asArray()) {
              count += a2.children.size;
            }
          }
        }

        return <div className="nav-C4">({count})</div>;
      } else {
        return "";
      }
    }
  }

  handleDelete(): void {
    // ask first if user really wants to delete all group addresses
    state.dialogManager.openDialog(
      <ConfirmDialog
        title={itx("groupAddressesTreeViewModel.confirmDeleteAllTitle", "Alle Gruppenadressen löschen?")}
        text={itx(
          "groupAddressesTreeViewModel.confirmDeleteAllText",
          "Möchten Sie wirklich alle Gruppenadressen löschen?",
        )}
        onOk={() => {
          GroupAddress.deleteAllGroupAddressesExceptOfManuals();

          //
          // Clear References to all DELETED GroupAddresses ..
          //   ... in all signals of all channels in all devices
          //
          GroupAddress.deleteAllReferencesToGroupAddresses(true);
          return true;
        }}
      />,
    );
  }

  get contextMenuItems(): any {
    const items = [
      {
        key: "generateAdresses",
        label: itx("treeViewModel.generateAdresses", "KNX Gruppenadressen erzeugen"),
        iconName: "list-ol", // no itx
        onClick: async () => {
          await askForGroupAddressUpdate(true);
          this.typedObj.raiseOnChange("expanded");
        },
      },
    ];
    if (state.addresses.size > 0) {
      if (state.projectLicense.checkLicenses(ProjectLicenseType.ExcelExport)) {
        items.push({
          key: "exportGroupAddresses",
          label: itx("treeViewModel.exportGroupAddresses", "Gruppenadressen exportieren"),
          iconName: "upload", // no itx
          onClick: async () => {
            state.dialogManager.openDialog(<ExportGroupAdressesDialog />);
          },
        });
      }
      items.push({
        key: "deleteAllAdresses",
        label: itx("groupAdressesTreeViewModel.deleteAllAdresses", "Alle Gruppenadressen löschen"),
        iconName: "trash", // no itx
        onClick: async () => {
          await this.handleDelete();
        },
      });
    }
    return {
      title: itx("treeViewModel.groupAddresses", "Gruppenadressen"),
      items: items,
    };
  }

  //  getButtons(): JSX.Element[] | undefined { return [this.inlineButton_Information()];}
  getButtons(): JSX.Element[] | undefined {
    const res = [
      <TreeMenuIcon
        onClick={async () => {
          await askForGroupAddressUpdate(false);
          this.typedObj.raiseOnChange("expanded");
        }}
        iconName="list-ol" // no itx
        tooltipKey="treeViewModel.generateAdresses" // no itx
        objName={this.obj.className + this.obj.fullTag}
        key={this.obj.className + this.obj.fullTag + "GroupAddresses"} // no itx
      />,
    ];
    if (state.addresses.size > 0) {
      if (state.projectLicense.checkLicenses(ProjectLicenseType.ExcelExport)) {
        res.push(
          <TreeMenuIcon
            onClick={() => {
              state.dialogManager.openDialog(<ExportGroupAdressesDialog />);
            }}
            iconName="upload" // no itx
            tooltipKey="treeViewModel.exportGroupAddresses" // no itx
            objName={this.obj.className + this.obj.fullTag}
            key={this.obj.className + this.obj.fullTag + "ExportGroupAddresses"} // no itx
          />,
        );
      }
      res.push(
        this.inlineButton_Delete("groupAdressesTreeViewModel.deleteAllAdresses"), // no itx
      );
    }

    return res;
  }
}
